<script setup lang="ts"></script>
<template>
  <svg
    style="width: 0; height: 0; position: absolute"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <!-- pink gradient -->
      <linearGradient id="bg-primary-pink-gradient" x2="1" y2="1">
        <stop offset="0%" stop-color="#d839ff" />
        <stop offset="100%" stop-color="#771f8c" />
      </linearGradient>

      <!-- blue gradient -->
      <linearGradient id="bg-primary-blue-gradient" x2="1" y2="1">
        <stop offset="0%" stop-color="#0068ff" />
        <stop offset="100%" stop-color="#004ab5" />
      </linearGradient>

      <!-- dark icon gradient -->
      <linearGradient
        id="dark-gradient"
        x1="16"
        y1="2.67"
        x2="16"
        y2="27.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6A6B7C" />
        <stop offset="1" stop-color="#2F2F37" />
      </linearGradient>

      <!-- light icon gradient -->
      <linearGradient
        id="light-gradient"
        x1="16"
        y1="2.67"
        x2="16"
        y2="27.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8F8F9" />
        <stop offset="1" stop-color="#C5C6CE" />
      </linearGradient>

      <!-- gold bonus gradient -->
      <linearGradient id="goldGradient">
        <stop offset="0" stop-color="#E5A800" />
        <stop offset="1" stop-color="#FFC018" />
      </linearGradient>

      <!-- rewards gold gradient -->
      <linearGradient
        id="rewards-gold-gradient"
        x1="4.17578"
        y1="42.192"
        x2="32.2126"
        y2="30.4672"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0001" stop-color="#D87700" />
        <stop offset="1" stop-color="#FFC018" />
      </linearGradient>

      <!-- Wreath gold gradient -->
      <linearGradient
        id="wreath-gold-gradient"
        gradientTransform="rotate(11, 0.5, 0.5)"
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
      >
        <stop stop-color="#ffc018" stop-opacity="1" offset="0%"></stop>
        <stop stop-color="#d87700" stop-opacity="1" offset="100%"></stop>
      </linearGradient>

      <!-- ROA primary gradient -->
      <linearGradient
        id="new-pink-gradient"
        x1="7.99967"
        y1="14"
        x2="7.99967"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5B186B" />
        <stop offset="1" stop-color="#D839FF" />
      </linearGradient>

      <!-- ZA Primary Gradient -->
      <linearGradient
        id="new-blue-gradient"
        x1="8"
        y1="14"
        x2="13.2827"
        y2="5.15526"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#004AB5" />
        <stop offset="1" stop-color="#0068FF" />
      </linearGradient>

      <!-- icon dark gradient -->
      <linearGradient
        id="icon-dark-gradient"
        x1="7.85833"
        y1="2"
        x2="7.85833"
        y2="13.7167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8F8F9" />
        <stop offset="1" stop-color="#C5C6CE" />
      </linearGradient>

      <!-- icon light gradient -->
      <linearGradient
        id="icon-light-gradient"
        x1="7.85833"
        y1="2"
        x2="7.85833"
        y2="13.7167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6A6B7C" />
        <stop offset="1" stop-color="#2F2F37" />
      </linearGradient>
    </defs>
  </svg>
</template>
